// TODO: if Android, window.open

import React, { useEffect, useState, useRef } from "react";
import loadingIcon from "../../Assets/loading.gif";
import queryString from "query-string";
import { Link, Redirect, useLocation } from "react-router-dom";
import axios from "axios";
// import AppleIcon from "@material-ui/icons/Apple";
// import AndroidIcon from "@material-ui/icons/Android";
import {
  Apple as AppleIcon,
  Android as AndroidIcon,
} from "@mui/icons-material";
import mixpanel from "mixpanel-browser";
import { isAndroid, isIOS } from "react-device-detect";
import userStore from "../../Stores/User";
import { observer } from "mobx-react";
import PodcastSetup from './Components/PodcastSetup';
import Loader from '../../Components/Loader';

const BACKEND_ENDPOINT = process.env.REACT_APP_BACKEND_URL;

const SetupNew = observer(() => {
  const location = useLocation();
  const { feed_url } = queryString.parse(location.search);
  const userFeedUrl = feed_url || userStore.userFeedUrl;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading time for the component to initialize
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  if (!userFeedUrl) {
    return null;
  }

  return <PodcastSetup userFeedUrl={userFeedUrl} />;
});

export default SetupNew;
